/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ApiDocsService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns binary return this API documentation
     * @throws ApiError
     */
    public getApiDocs(): CancelablePromise<Blob> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api-docs',
        });
    }

}
